"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { captureException } from "@/lib/sentry";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error, (scope) => {
      scope.setTag?.("origin", "next.global-error");
      scope.setContext?.("error", {
        digest: error.digest ?? "unknown",
      });
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
        <div className="grid max-w-md gap-3 rounded-lg border border-border bg-card p-6">
          <h2 className="text-lg font-semibold">Something went wrong</h2>
          <p className="text-sm text-muted-foreground">
            An unexpected error occurred. Try again, and if it persists contact support.
          </p>
          <Button type="button" onClick={() => reset()}>
            Try again
          </Button>
        </div>
      </body>
    </html>
  );
}

